import styled from 'styled-components';
export const Container = styled.div.withConfig({
  displayName: "Mainstyle__Container",
  componentId: "sc-97fgad-0"
})(["", ""], {
  "marginTop": "1rem",
  "marginBottom": "1rem",
  "display": "flex",
  "flexDirection": "column",
  "gap": "0.5rem"
});
export const Title = styled.h1.withConfig({
  displayName: "Mainstyle__Title",
  componentId: "sc-97fgad-1"
})(["", " @media (max-width:", "){", "}"], {
  "fontSize": "45px",
  "fontWeight": "700",
  "lineHeight": "50px",
  "--tw-text-opacity": "1",
  "color": "rgb(23 23 23 / var(--tw-text-opacity, 1))"
}, ({
  theme
}) => theme.breakpoint.md, {
  "fontSize": "1.875rem",
  "lineHeight": "34px"
});
export const Detail = styled.div.withConfig({
  displayName: "Mainstyle__Detail",
  componentId: "sc-97fgad-2"
})(["", " @media (max-width:", "){", "}"], {
  "fontSize": "28px",
  "fontWeight": "400",
  "lineHeight": "30px",
  "--tw-text-opacity": "1",
  "color": "rgb(88 88 88 / var(--tw-text-opacity, 1))"
}, ({
  theme
}) => theme.breakpoint.md, {
  "fontSize": "1.5rem",
  "lineHeight": "2rem"
});
export const MainAction = styled.div.withConfig({
  displayName: "Mainstyle__MainAction",
  componentId: "sc-97fgad-3"
})(["", ""], {
  "display": "flex",
  "alignItems": "baseline",
  "justifyContent": "space-between"
});
export const ListTag = styled.div.withConfig({
  displayName: "Mainstyle__ListTag",
  componentId: "sc-97fgad-4"
})(["", " span{", "}"], {
  "display": "flex",
  "flexWrap": "wrap",
  "gap": "0.5rem"
}, {
  "fontSize": "1rem !important",
  "lineHeight": "1.5rem !important"
});